@use '@/styles/mastodon/mixins';

.root {
  border: 0.5px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: var(--space-sm);
  position: relative;
  transition: background 200ms ease-in-out;

  &:has(.image) {
    column-gap: var(--space-sm);
    display: grid;
    grid-template-columns: minmax(0, 1fr) 120px;
    padding-inline-end: 0;
  }
}

// Handle cases where the root is a link
a.root {
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  &:focus,
  &:focus-visible {
    border-radius: var(--radius-md);
    outline: var(--outline-focus-default);
    outline-offset: 2px;
  }
}

.title {
  @include mixins.type-label-md;

  color: var(--color-text-secondary);
  display: flex;

  a {
    color: inherit;
    text-decoration: none;

    &:hover,
    &:active {
      text-decoration: underline;
    }
  }
}

.titleImage {
  border-radius: var(--radius-round);
  display: block;
  height: var(--space-lg);
  margin-inline-end: var(--space-xs);
  overflow: hidden;
  width: var(--space-lg);
}

.body {
  @include mixins.type-label-lg;

  overflow-wrap: break-word;
  flex-grow: 1;

  * + & {
    margin-block-start: var(--space-xs);
  }

  a {
    color: var(--color-text-brand);
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
}

// Linked body
a.body {
  padding-inline: var(--space-sm);
  margin-inline: calc(-1 * var(--space-sm));
  color: inherit;
  text-decoration: none;

  .root:has(&:hover) {
    background-color: var(--color-bg-highlight);
  }
}

.description {
  @include mixins.type-body-compact;
}

.image {
  contain: size;
  grid-column: 2;
  grid-row: 1 / span 2;
  margin-block: calc(-1 * var(--space-sm));

  &,
  & > img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}

.clamp {
  @include mixins.line-clamp(2);
}

.delete {
  position: absolute;
  top: var(--space-xs);
  right: var(--space-xs);
}
